// Single source of truth for color variant styles.
// Contentful stores the token name; this map owns the classes.
// Never put color values inside a component — read from here via resolveColorVariant.

export const colorVariants = {
  white: {
    bg: "",
    text: "text-brand-primary-darker",
    badge: "bg-brand-tertiary-50",
    card: "bg-white",
    accent: {
      border: "border-brand-greens-regular",
      bg: "bg-brand-greens-regular",
    },
    connector: {
      border: "border-brand-primary-lighter",
      bg: "bg-brand-primary-lighter",
    },
  },
  beige: {
    bg: "bg-brand-beige-light",
    text: "text-brand-primary-darker",
    badge: "bg-brand-tertiary-50",
    card: "bg-white",
    accent: {
      border: "border-brand-greens-regular",
      bg: "bg-brand-greens-regular",
    },
    connector: {
      border: "border-brand-primary-lighter",
      bg: "bg-brand-primary-lighter",
    },
  },
  lightGreen: {
    bg: "bg-brand-moss-greens-10",
    text: "text-brand-primary-darker",
    badge: "bg-brand-tertiary-30",
    card: "bg-white",
    accent: {
      border: "border-brand-greens-regular",
      bg: "bg-brand-greens-regular",
    },
    connector: {
      border: "border-brand-primary-lighter",
      bg: "bg-brand-primary-lighter",
    },
  },
  darkGreen: {
    // Routed through the scheme's inverse-surface tokens: default resolves to
    // the same dark green, toll-brothers renders toll navy.
    bg: "bg-scheme-surface-inverse",
    text: "text-scheme-text-on-inverse",
    badge: "bg-white text-scheme-surface-inverse",
    card: "bg-transparent",
    accent: {
      border: "border-brand-greens-light",
      bg: "bg-brand-greens-light",
    },
    connector: {
      border: "border-brand-primary-regular",
      bg: "bg-brand-primary-regular",
    },
  },
  image: {
    bg: "bg-transparent",
    text: "text-white",
    badge: "bg-white/20",
    card: "bg-transparent",
    accent: {
      border: "border-white",
      bg: "bg-white",
    },
    connector: {
      border: "border-white/30",
      bg: "bg-white/30",
    },
  },
} as const;

export type ColorVariant = keyof typeof colorVariants;
